export default __webpack_public_path__ + "static/media/sponsorprinc.2b6a1be2.gif";